module.exports = __webpack_public_path__ + "img/GO_01.1282d94a.png";